module.exports = __webpack_public_path__ + "static/media/linkdin.2c02b526.png";